// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingOverlay_root__11aTl","spinner":"LoadingOverlay_spinner__1IIe5"};